import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n  from,\n  to {\n    transform: translate3d(0, 0, 0);\n  }\n\n  17%,\n  51% {\n    transform: translate3d(-10px, 0, 0);\n  }\n\n  34%,\n  68% {\n    transform: translate3d(10px, 0, 0);\n  }\n\n  84% {\n    transform: translate3d(-5px, 0, 0);\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { keyframes } from 'styled-components';
export var buttonShakeAnimationKeyframes = keyframes(_templateObject());